import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueAMap from 'vue-amap'

Vue.use(VueAwesomeSwiper) 
Vue.use(VueAMap) 

Vue.config.productionTip = false

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '49ba96e052d53787eb4bfc1c5b7730ec',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

//axios全局配置
window.axios = axios
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.baseURL = 'https://node.chezhentong.com/api/'; //接口地址
axios.defaults.baseURL = 'https://t.api.chezhentong.com/api/'; //测试接口地址

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
